import { useState } from 'react'
import { HelpCircle } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import HelpDrawer from './HelpDrawer'
import { findHelpContent } from '@/help/helpContent'

export default function HelpButton() {
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)
  const content = findHelpContent(pathname)

  if (!content) return null

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 px-2.5 py-1.5 text-xs text-gray-500 hover:text-brand-600 hover:border-brand-300 hover:bg-brand-50 transition-colors"
        title="Справка по этому разделу"
      >
        <HelpCircle className="h-3.5 w-3.5" />
        Справка
      </button>
      {open && <HelpDrawer content={content} onClose={() => setOpen(false)} />}
    </>
  )
}
